var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDisputeBubble = function SvgDisputeBubble(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "inherit",
    height: "inherit",
    fill: "none",
    stroke: "var(--svg-stroke-color, inherit)",
    viewBox: "0 0 25 25"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "inherit",
    clipPath: "url(#dispute-bubble_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.106 22.011a11.143 11.143 0 1 0-4.382-3.836m4.382 3.836L.857 23.143l1.867-4.968m4.382 3.836h.008m-4.39-3.836.002-.004M11.857 6.143v6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.856 16.857a.428.428 0 1 1 0-.857M11.856 16.857a.429.429 0 1 0 0-.857"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "dispute-bubble_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgDisputeBubble;